import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";

const NAVY = "#0A0F2C";
const GOLD = "#C9A84C";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#F0F2F5] py-10 px-4 font-sans">
      <div className="w-full max-w-[420px] rounded-2xl overflow-hidden shadow-[0_24px_64px_rgba(0,0,0,0.18)] bg-white px-9 py-11"
        data-testid="forgot-password-shell">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-[48px] h-[48px] rounded-xl flex items-center justify-center text-[24px] font-semibold"
            style={{ backgroundColor: GOLD, color: NAVY }}>V</div>
          <div className="text-[22px] font-semibold tracking-[1.5px]" style={{ color: NAVY }}>
            VĀ<span style={{ color: GOLD }}>KU</span>
          </div>
        </div>

        {sent ? (
          <div data-testid="forgot-password-sent">
            <h2 className="text-[20px] font-semibold mb-2" style={{ color: "#0D1117" }}>Check your inbox</h2>
            <p className="text-[13.5px]" style={{ color: "#666" }}>
              If an account exists for <b>{email}</b>, we've sent a password reset link. It expires in 1 hour.
            </p>
          </div>
        ) : (
          <>
            <h2 className="text-[20px] font-semibold mb-1" style={{ color: "#0D1117" }} data-testid="forgot-password-title">
              Forgot your password?
            </h2>
            <p className="text-[13.5px] mb-6" style={{ color: "#666" }}>
              Enter your work email and we'll send you a reset link.
            </p>
            <form onSubmit={submit} className="space-y-[15px]" data-testid="forgot-password-form">
              <div>
                <label className="block text-[12.5px] font-medium mb-1.5" style={{ color: "#444" }}>Work email</label>
                <input
                  data-testid="forgot-password-email"
                  type="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  className="w-full h-10 rounded-lg px-3.5 text-[13.5px] outline-none"
                  style={{ border: "1px solid #DDE1E9", backgroundColor: "#FAFAFA", color: "#0D1117" }}
                />
              </div>
              {err && <div className="text-[12px] font-semibold text-[#DC2626]" data-testid="forgot-password-error">{err}</div>}
              <button
                data-testid="forgot-password-submit"
                type="submit" disabled={loading}
                className="w-full h-[42px] rounded-lg text-[14px] font-semibold text-white disabled:opacity-60 flex items-center justify-center gap-2"
                style={{ backgroundColor: NAVY }}
              >
                <EnvelopeSimple size={15} weight="bold" />
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        )}

        <Link to="/login" data-testid="forgot-password-back-to-login"
          className="mt-6 flex items-center gap-1.5 text-[13px] font-medium hover:underline" style={{ color: "#185FA5" }}>
          <ArrowLeft size={13} weight="bold" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
